module.exports = __webpack_public_path__ + "media/Gloeckchen.af54bc6f.mp3";